const FLAG_VIEWBOX = '0 0 32 24';

const FlagIcon = ({ code }) => {
	switch (code) {
		case 'pl':
			return (
				<svg
					viewBox={FLAG_VIEWBOX}
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="32" height="12" fill="#fff" />
					<rect y="12" width="32" height="12" fill="#dc143c" />
				</svg>
			);
		case 'de':
			return (
				<svg
					viewBox={FLAG_VIEWBOX}
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="32" height="8" fill="#111" />
					<rect y="8" width="32" height="8" fill="#dd0000" />
					<rect y="16" width="32" height="8" fill="#ffce00" />
				</svg>
			);
		case 'en':
			return (
				<svg
					viewBox={FLAG_VIEWBOX}
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="32" height="24" fill="#012169" />
					<path d="M0 0 L32 24 M32 0 L0 24" stroke="#fff" strokeWidth="4.8" />
					<path d="M0 0 L32 24 M32 0 L0 24" stroke="#c8102e" strokeWidth="2.4" />
					<path d="M16 0 V24 M0 12 H32" stroke="#fff" strokeWidth="8" />
					<path d="M16 0 V24 M0 12 H32" stroke="#c8102e" strokeWidth="4.8" />
				</svg>
			);
		case 'cs':
			return (
				<svg
					viewBox={FLAG_VIEWBOX}
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="32" height="12" fill="#fff" />
					<rect y="12" width="32" height="12" fill="#d7141a" />
					<path d="M0 0 L16 12 L0 24 Z" fill="#11457e" />
				</svg>
			);
		default:
			return null;
	}
};

export default FlagIcon;
